__turbopack_context__.v({
  "container": "InternationalPhone-module__0fpKcG__container",
  "disabled": "InternationalPhone-module__0fpKcG__disabled",
  "error": "InternationalPhone-module__0fpKcG__error",
  "input": "InternationalPhone-module__0fpKcG__input",
  "wrapper": "InternationalPhone-module__0fpKcG__wrapper",
});
